export default __webpack_public_path__ + "static/media/manage_employee.64cc4b0b.svg";